export default "__VITE_ASSET__mfDlRgWa__"